// extracted by mini-css-extract-plugin
module.exports =  {"nowrap":"_93444fe79c--nowrap--QbNay","wrap":"_93444fe79c--wrap--UqD6F"};